import {AfterViewInit, Component, EventEmitter, OnInit, Input, Output, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort, Sort} from '@angular/material/sort';
import {ActionData, TableColumn} from '../../interfaces/table-column';
import {DatePipe} from '@angular/common';
import {CustomPageRequest, Pageable} from '../../../@services/gen';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {Router} from '@angular/router';

@Component({
  selector: 'ngx-ng-material-table',
  templateUrl: './ng-material-table.component.html',
  styleUrls: ['./ng-material-table.component.scss'],
})
export class NgMaterialTableComponent implements OnInit, AfterViewInit {
  // Note: use dot(.) to display relation column. Example: posItemCategory.name

  public tableDataSource = new MatTableDataSource([]);
  public displayedColumns: string[];
  @ViewChild(MatPaginator, {static: false}) matPaginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) matSort: MatSort;

  @Input() isPageable = false;
  @Input() isSortable = false;
  @Input() tableColumns: TableColumn[];
  @Input() columnRowSelection: ActionData;
  @Input() rowActionIcon: string;
  @Input() paginationSizes: number[] = [10, 20, 30];
  @Input() pageSize = this.paginationSizes[1];
  @Input() totalRow: number;
  pageEvent: PageEvent;
  @Input()
  pageIndex = 0;

  @Output() sort: EventEmitter<Sort> = new EventEmitter();

  @Output('setPageEmitter') setPageEmitter: EventEmitter<CustomPageRequest> = new EventEmitter();
  @Output('handleTableAction') handleTableAction: EventEmitter<any> = new EventEmitter();

  // this property needs to have a setter, to dynamically get changes from parent component
  @Input() set tableData(data: any[]) {
    this.setTableDataSource(data);
  }

  constructor(public datepipe: DatePipe, private sanitizer: DomSanitizer, private router: Router) {}

  ngOnInit(): void {
    const columnNames = this.tableColumns.map((tableColumn: TableColumn) => tableColumn.name);

    this.displayedColumns = columnNames;

    this.displayedColumns.unshift('sn');
    this.displayedColumns.push('lastUpdate');

    this.setPageEmitter.emit({page: this.pageIndex, size: this.pageSize});
  }

  // we need this, in order to make pagination work with *ngIf
  ngAfterViewInit(): void {
    this.matPaginator.pageIndex = this.pageIndex;
    this.matPaginator.pageSize = this.pageSize;

    // this.tableDataSource.paginator = this.matPaginator;
  }

  setTableDataSource(data: any) {
    this.tableDataSource = new MatTableDataSource<any>(data);
    this.tableDataSource.sort = this.matSort;
  }

  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.setPageEmitter.emit({page: this.pageIndex, size: this.pageSize});
  }

  getPagingIndex(index) {
    return +this.pageIndex * +this.pageSize + (index + 1);
  }

  getLastUpdate(element) {
    if (element) {
      if (element.updateTime) {
        return `<span class="font-weight-bold">${this.capitalize(element.updatedByName)}</span> <br>
            <span class="text-muted">${this.datepipe.transform(element.updateTime, 'dd MMM yyyy hh:mm:ss a')}</span>`;
      } else {
        return `<span class="font-weight-bold">${this.capitalize(element.createdByName)}</span> <br>
            <span class="text-muted">${this.datepipe.transform(element.creationTime, 'dd MMM yyyy hh:mm:ss a')}</span>`;
      }
    }

    return '-';
  }

  capitalize(s) {
    return s[0].toUpperCase() + s.slice(1);
  }

  emitParentTableAction(id, type) {
    const res = {
      id: id,
      type: type,
    };

    this.handleTableAction.emit(res);
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  openPage(routerLink: any, param2: {id: any; type: string}) {
    this.router.navigate(routerLink, {queryParams: param2});
  }

  firstPage() {
    this.matPaginator.firstPage();
  }
}
